import React from 'react';
import type { CFSceneView } from '@types';
import Button from '@components/Button';

type Props = {
  onLookToClick: (view: CFSceneView) => void;
} & CFSceneView;

function SwitchViewSetting({ atv, ath, fov, onLookToClick }: Props) {
  const hasSet = ![ath, atv, fov].includes(undefined);
  return (
    <div className="mt-10 rounded bg-black-#28 p-10">
      {hasSet ? (
        <div className="flex h-30 items-center rounded bg-black-#34">
          <Button
            className="w-full"
            onClick={() => onLookToClick({ ath, atv, fov })}
          >
            定位到当前视角
          </Button>
        </div>
      ) : (
        <div className="flex h-30 items-center justify-center rounded bg-black-#34">
          暂未设置视角
        </div>
      )}
    </div>
  );
}

export default SwitchViewSetting;
